import React from "react";
import { Familia, Subfamilia } from "./../../classes/familia";
import "./FamiliaNav.scss";
import { Link } from "react-router-dom";

const FamiliaNav: React.FunctionComponent<{ familias: Familia[]; match: any }> =
  React.memo(({ familias = [], match }) => {
    const scrollToElement = (elementId: string) => {
      const elmnt: any = document.getElementById(elementId);
      elmnt.scrollIntoView();
    };

    const renderSubfamilias = (
      familia: Familia,
      collapse: string,
      heading: string
    ) => {
      if (!familia.SUBFAMILIAS.length) return;
      return (
        <ul
          aria-labelledby={heading}
          className="collapse"
          data-parent="#husky-zalazar-FamiliaNav"
          id={collapse}
        >
          {familia.SUBFAMILIAS.map((s: Subfamilia, index: number) => (
            <li
              className="collapsed SubfamiliaItem"
              key={index}
              onClick={() =>
                scrollToElement(`husky-zalazar-Familia-${familia.ID_FLIA}`)
              }
            >
              <Link
                to={`${match.url}?familia=${familia.ID_FLIA}&subfamilia=${s.ID_SUBF}`}
              >
                <button
                  aria-controls={collapse}
                  aria-expanded="false"
                  className="card-header collapsed SubfamiliaBtn"
                  id={heading}
                >
                  {s.NSUBF}
                </button>
              </Link>
            </li>
          ))}
        </ul>
      );
    };

    return (
      <ul className="FamiliasList accordion" id={`husky-zalazar-FamiliaNav`}>
        {familias.map((familia: Familia) => {
          const collapse: string = `husky-zalazar-collapse${familia.ID_FLIA}`;
          const heading: string = `husky-zalazar-heading${familia.ID_FLIA}`;

          return (
            <li
              className="card FamiliaItem"
              id={`husky-zalazar-Familia-${familia.ID_FLIA}`}
              key={`husky-zalazar-Familia-${familia.ID_FLIA}`}
              onClick={() =>
                scrollToElement(`husky-zalazar-Familia-${familia.ID_FLIA}`)
              }
            >
              <Link to={`${match.url}?familia=${familia.ID_FLIA}`}>
                <button
                  aria-controls={collapse}
                  aria-expanded="false"
                  className="card-header collapsed FamiliaBtn"
                  data-target={`#${collapse}`}
                  data-toggle="collapse"
                  id={heading}
                >
                  {familia.NFAMILIA}{" "}
                  {familia.SUBFAMILIAS.length ? (
                    <span className="ExpandSubfamilias">+</span>
                  ) : null}
                </button>
              </Link>
              {renderSubfamilias(familia, collapse, heading)}
            </li>
          );
        })}
      </ul>
    );
  });

export default FamiliaNav;
